import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom"

import './index.css';

import App from './App';
import { persistor, store } from './Pages/ReduxStore/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
  <App />
  </PersistGate>
  </Provider>
  </BrowserRouter>
);



